package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.delete_furniture


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("deleteFurniture")
    val deleteFurniture: Int?,
    @SerialName("__typename")
    val typename: String?
)